/* eslint-disable import/prefer-default-export */
export const EVENT = {
    MESSAGE: {
        EMISSION_ERROR: "Hola, tengo un error al emitir desde PASAP",
    },
    KEY: {
        INIT: "init",
        DASHBOARD: "dashboard",
        MODAL_HELP: "modal_help",
        MULTIQUOTE_CREATE: "multiquote_create", // cotización exitosa de autos y otros riesgos
        BILL_DOWNLOAD: "bill_download", // descarga factura de cuenta corriente
        LIQUIDATION_DOWNLOAD: "liquidation_download", // descarga liquidación de cuenta corriente
        DOCUMENT_DOWNLOAD_SELF_MANAGEMENT: "self_management_document_download", // descarga documentación de autogestión
        DOCUMENT_DOWNLOAD: "document_download", // descargar documentación de ciertos lugares (#todo: agregar el resto)
        EMISSION_ERROR_WSP: "wsp_emission_error", // presionar botón de whatsapp en error de emisión
        EMISSION_ERROR: "emission_error", // error de emisión de autos y otros riesgos
        EMISSION_SUCCESS: "emission_success", // emisión exitosa de autos y otros riesgos
    },
};
